import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './appliedCouponSummary.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { LocalOfferOutlined } from '@material-ui/icons';

type Props = {
  code: string;
  name: string;
  description: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRequestDelete: () => any;
};

export const AppliedCouponSummary = observer(({ code, name, description, onRequestDelete }: Props) => {
  return (
    <>
      <div styleName="name">適応中のクーポン</div>
      <div styleName="summary">
        <div styleName="header">
          <div>
            <div className="coupon-code" styleName="code">
              {code}
            </div>
            <div styleName="name">
              <LocalOfferOutlined styleName="coupon-icon" />
              {name}
            </div>
          </div>
          {GlobalStatesV3.viewport.isNonSp && (
            <Button type="normal" styleName="delete-button" size="m" onClick={onRequestDelete}>
              クーポンを削除する
            </Button>
          )}
        </div>
        <div styleName="description">{description}</div>
        {GlobalStatesV3.viewport.isSp && (
          <Button type="normal" styleName="delete-button" size="m" onClick={onRequestDelete}>
            クーポンを削除する
          </Button>
        )}
      </div>
    </>
  );
});
